import { render } from "./ProductIdentified.vue?vue&type=template&id=1698eae1&scoped=true"
import script from "./ProductIdentified.vue?vue&type=script&lang=js"
export * from "./ProductIdentified.vue?vue&type=script&lang=js"

import "./ProductIdentified.vue?vue&type=style&index=0&id=1698eae1&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1698eae1"]])

export default __exports__